<div  class="card border-light shadow-sm" id="permitConfirm">
  <ngx-loading [show]="pageload"></ngx-loading>
  <app-busy class="col-12" *ngIf="pageload2" [message]="message"></app-busy>

 <div class="container-fluid Confirmation-invoice" >
     <div class="content" #content id="PDFcontent">
       <h4 style="text-align:Left;">
          <i class="fa fa-check-square-o"></i>
          Permit Approval: <span style="font-weight:200; font-size: 85%;">{{dataCntrl['permittype'].description}}</span>
      </h4>
      <br>
     <div class="confirmation-block" id="confirm-content">
         <div class="col-md-12 p-0 row">
           <div class="col-md-10 row p-0">
            <div class="col-sm-6">
              <h4 style="margin-bottom:-5px;padding-left:3%">
                <span style="padding-right:5px"></span>
                <b>1. Carrier Details</b>
              </h4>
            </div>
          <!--  <div class="col-sm-6">
              <h6 style="margin-bottom:20px;padding-left:0%">
                <span style="padding-right:5px"></span>
                <i class="fa fa-map-marker"></i>
                <b>Physical Address</b>
              </h6>
            </div>-->
           </div>
           </div>
           <!-- <div class="col-md-2">
            <h6 style="margin-bottom:20px;">
              <b>Document Uploads</b>
            </h6>
          </div> -->
           <div class="row mb-3 col-md-12">
             <div style="margin-bottom:10px;" class="col-sm-5 p-0">
               <div class="col-md-10">
                 <table class="table-1" id="pdfTable-1">
                  <tbody>
                    <br/>
                    <tr>
                      <td width="130px; height: 20px"><span class = "head-text"><b>Carrier Number: </b></span> </td>
                      <td width="auto"><span class="pl-2">{{dataCntrl['carrier'].carrier_code}}</span></td>
                    </tr>
                   <tr>
                    <td><span class = "head-text"><b>Carrier Name: </b></span></td>
                    <td><span class="pl-2">{{dataCntrl['carrier'].name}}</span></td>                    
                   </tr>
                   <!-- <tr>
                     <td><span class = "head-text"><b>Trading Name: </b></span></td>
                     <td><span class="pl-2"> {{dataCntrl['carrier'].trading_name}}</span></td>
                   </tr> -->
                   <tr>
                    <td><span class = "head-text"><b>Telephone No.: </b></span></td>
                    <td *ngIf="dataCntrl['carrier'].country_dial_code != ''"><span class="pl-2">+{{dataCntrl['carrier'].country_dial_code}} {{dataCntrl['carrier'].telephone}}</span></td>
                    <td *ngIf="dataCntrl['carrier'].country_dial_code == ''"><span class="pl-2">({{dataCntrl['carrier'].country_code}}) {{dataCntrl['carrier'].telephone}}</span></td>
                  </tr>
                  <tr>
                   <td><span class = "head-text"><b>Email Address: </b></span></td>
                   <td><span class="pl-2">{{dataCntrl['carrier'].email}}</span></td>
                 </tr>
                 <!-- <tr>
                     <td><span class = "head-text">Permit Application Nnumber:</span></td>
                     <td><span class="pl-2">{{dataCntrl['carrier'].carrier_code}}</span></td>
                   </tr>
                   <tr>
                     <td><span class = "head-text">Application Date:</span></td>
                     <td><span class="pl-2">{{dataCntrl['application'].date_created | date :'dd-MM-yyyy'}}</span></td>
                   </tr>-->
                  </tbody>
                 </table>
               </div>
             </div>
             <div style="margin-left:0px;margin-bottom:10px; float: right; position: relative; left: 250px;" class="col-sm-5 p-0">
               <div class="col-md-10">
                  <h6>Physical Address</h6>
                 <table class="table-1" id="pdfTable-1" style="margin-left: 30px; margin-top:-5px;">
                   <!-- <tbody>
                     <tr>
                        <td><h6>Physical Address</h6></td>
                    </tr>
                  </tbody> -->
                  <tbody>
                    <tr>
                      <td class="addrees-td-1" width="100px;"><span class = "head-text"><b>Street Name: </b></span></td>
                      <td class="addrees-td" width="auto"><span class="pl-2">{{dataCntrl['carrier'].physical_address_1}}</span></td>
                    </tr>   
  <!--                                    
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text">Address Line2:</span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_2}}</span></td>
                    </tr>
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text">Address Line3:</span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_3}}</span></td>
                    </tr>
  -->
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text"><b>Town: </b></span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_town}}</span></td>
                    </tr>
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text"><b>Postal Code: </b></span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_post_code}}</span></td>                    
                     </tr>
                     <tr>
                       <td class="addrees-td-1"><span class = "head-text"><b>Country: </b></span></td>
                       <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].country_description}}</span></td>
                     </tr>
                     </tbody>
                 </table>
               </div>
             </div>
			   </div>
            <hr>
             <div >
              <h4 ><b>2. Permit Details</b></h4>
            </div>

            <table class="table-1" id="pdfTable-1">
              <tbody>
                <tr>
                  <td style="padding-left:15px;"><span class = "head-text">Application Date: </span> {{dataCntrl['application'].date_created | date :'dd/MM/yyyy'}} </td>               
               <br/>  
                </tr>
                
                <tr>  
                <br/>      
              <td id="Money" name="Money"><span class = "pull-right" >Account Balance: {{dataCntrl['carrier'].account_balance}}</span></td>              
             </tr>        
                               
            </tbody>
            </table>

              <table class="table table-sm table-striped" id="pdfTable" style="margin-left:15px;">
                <thead>
                 <tr>
                     <th>Permit Type</th>
                     <th>Start Date</th>
                     <th>Duration</th>
                     <th>Vehicle Reg</th>
                     <th>Vehice Type</th>
                   <!-- <th >License Expiry Date</th> -->
                   <!--  <th>GVM</th> -->
                     <th>VIN Number</th>
                     <th>Application Fee</th>
                     <th>Permit Fee</th>
                     <th>Line Total</th>
                     <!--<th>Status</th>-->
                   </tr>
             </thead>
             <tbody>
                 <tr *ngFor="let list of vehicles">
                  <td >{{dataCntrl['permittype'].description}}</td>                  
                  <td >{{list.start_date}}</td> 
                  <ng-container *ngIf="ptype == null">
                    <td *ngIf="dataCntrl['permittype'].permit_years > 0">{{dataCntrl['permittype'].permit_years}} - Years</td>
                    <td *ngIf="dataCntrl['permittype'].permit_months > 0">{{dataCntrl['permittype'].permit_months}} - Months</td>
                    <td *ngIf="dataCntrl['permittype'].permit_days > 0">{{dataCntrl['permittype'].permit_days}} - Days</td>
                  </ng-container>
                  <ng-container *ngIf="ptype != null">
                    <td *ngIf="ptypeYears > 0">{{ptypeYears}} - Years</td>
                    <td *ngIf="ptypeMonth > 0">{{ptypeMonth}} - Months</td>
                    <td *ngIf="ptypeDays > 0">{{ptypeDays}} - Days</td>
                  </ng-container>
                  <td >{{list.registration_number}}</td>
                  <td >{{list.vehicle_type}}</td>

                <!--   <td>{{list.gvn}}</td>-->
                  <td>{{list.vin}}</td>
               <!--  <td>{{list.date_license_expiry}}</td> -->
                   <td >{{formatCurrency(list.application_fee)}}</td>
                   <td >{{formatCurrency(list.permit_fee)}}</td>
                   <td >{{formatCurrency(list.lineTotal)}}</td>
                 </tr>
                 <tr>
                   <td colspan="8" style="text-align:right;">Total: </td>
 
                   <td> {{formatCurrency(totalFee) }}</td>
                 </tr>
                 <!--<tr>
                  <td colspan="8" style="text-align:right;">Status: ></td>
                  <td>{{dataCntrl['status']?.description}}</td>
                 </tr>-->
               <!--  <div class="pull-left">
                  <span class = "head-text">Account Balance: {{dataCntrl['carrier'].account_balance}}</span>
                </div>-->
              <br/>
              
                
                 </tbody>
                 
             </table>
             <div *ngIf="dataCntrl.permittype.annual_compliance_reqd">
                <hr>
                <div >
                <h4 ><b>2.1 Annual Compliance Details</b></h4>
                </div>
              <table class="table table-sm table-striped" id="cpdfTable" style="margin-left:15px;">
              <thead>
               <tr>
                   <th>Permit Type</th>
                   <th>End Date</th>
                   <th>Year</th>
                   <th>Vehicle Reg</th>
                   <th>Vehice Type</th>
                 <!-- <th >License Expiry Date</th> -->
                 <!--  <th>GVM</th> -->
                   <th>VIN Number</th>
                   <th>Status</th>
                   <th>Application Fee</th>
                   <th>Permit Fee</th>
                   <th>Line Total</th>
                 </tr>
           </thead>
           <tbody>
               <tr *ngFor="let clist of complianceCertficateList">
                <td >{{clist.PermitType}}</td>   
                <td >{{clist.ComplianceEndDate | date:'dd/MM/yyyy'}}</td>   
                <td >{{clist.Year}}</td>              
                <td >{{clist.RegistrationNumber}}</td>
                <td >{{clist.vehicle_type}}</td>
                <td >{{clist.Vin}}</td>  
                <td >{{clist.ComplianceStatusDescription}}</td>  
                <td >{{formatCurrency(clist.ApplicationFee)}}</td>
                <td >{{formatCurrency(clist.PermitFee)}}</td>
                <td >{{formatCurrency(clist.ApplicationFee + clist.PermitFee)}}</td>
               </tr>
               <!-- <tr>
                 <td colspan="8" style="text-align:right;">Total :</td>

                 <td> {{formatCurrency(clist.LineTotal)}}</td>
               </tr> -->
          
            <br/>
            
              
               </tbody>
               
           </table>
             </div>


             <div>
              <h4><b>3. Route Details</b></h4>
            </div>
             <div class="col-md-12 p-0">
              <route-viewer [dataCntrl]="dataCntrl"></route-viewer>
            </div>

            <div *ngIf="dataCntrl.permittype.timetable_reqd">
              <h4><b>3.1 Time Table Details</b></h4>
            </div>
             <div *ngIf="dataCntrl.permittype.timetable_reqd" class="col-md-12 p-0">
              <app-timetable [dataCntrl]="dataCntrl" isApproval = "true"></app-timetable>
            </div>

            <div>
              <h4><b>4. Motivation</b></h4>
            </div>
            <div class="col-md-12 p-0 mb-5">
              <motivation-viewer  [dataCntrl]="dataCntrl"></motivation-viewer>
            </div>

            <div>
              <h4><b>5. Supporting Documents</b></h4>
              </div>
              <div class="col-md-12 p-0 mb-5">
                <uploads-viewer id="suppDocs" name="suppDocs" isPermitApproval="true"  [dataCntrl]="dataCntrl"></uploads-viewer>
              </div>
            </div>
            <div *ngIf="dataCntrl.permittype.annual_compliance_reqd">
              <div>
                <h4><b>6. Compliance Documents</b></h4>
              </div>
              <div *ngFor="let comps of complianceCertficateList">
                <div>
                  <h6><b>Permit Number: {{comps.PermitNumber}} | Vehicle: {{comps.RegistrationNumber}} | Compliance Year: {{comps.Year}}</b></h6>
                </div>
                <div class="col-md-12 p-0 mb-5">
                  <uploads-viewer id="comps.ComplianceDetailId"  name="comps.ComplianceDetailId" isPermitApproval="true" isComplianceDocuments="true" [complianceDetailId]="comps.ComplianceDetailId"  [dataCntrl]="dataCntrl"></uploads-viewer>
                </div>
              </div>
            </div>
       </div>

       <!--<div class="col-md-12 p-0" id="ignoreContent">
         <button title="Download PDF" name="download" type="submit" id="btnSave" (click)="downloadPdf()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Download PDF</button>
     </div>-->
   </div>
 </div>
